import { render } from "./TestimonialsThree.vue?vue&type=template&id=4b7364b4"
import script from "./TestimonialsThree.vue?vue&type=script&lang=js"
export * from "./TestimonialsThree.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__